const PILLARS = [
  {
    title: "Same-Day / Next-Day",
    desc: "No waiting two weeks for city bulk trash. We dispatch quickly with confirmed arrival windows so your project never stalls.",
  },
  {
    title: "Zero-Touch Loading",
    desc: "You don't carry anything out to the curb. Just point to the pile in the backyard, garage, or 2nd floor, and our crew hauls it.",
  },
  {
    title: "Local & Reliable Crew",
    desc: "Based right in Palm Bay, FL. We show up on time, communicate before arrival, and respect your property from gate to street.",
  },
];

export default function WhyUs() {
  return (
    <section id="why-dumpd" data-testid="why-us-section" className="py-24 bg-zinc-950 border-y border-white/10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-16">
          <h2 className="text-3xl sm:text-5xl font-black uppercase tracking-tighter font-display text-white">
            Why Brevard Calls DUMP'D
          </h2>
          <p className="text-zinc-400 text-sm sm:text-base mt-3">
            We built our operation around punctuality, brute strength, and respectful service for homeowners and managers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {PILLARS.map((p) => (
            <div key={p.title} className="border border-zinc-800 rounded-2xl p-8 bg-black/60">
              <h3 className="text-xl font-bold uppercase text-white mb-2">{p.title}</h3>
              <p className="text-sm text-zinc-400 leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
